import React from "react";
import { Box, BoxProps, Heading, Text } from "@chakra-ui/react";

export const HOME_PAGE_PX = {
  base: 6,
  md: 10,
  lg: 20,
  xl: 32,
};

export const HOME_PAGE_PY = {
  base: 6,
  md: 10,
  lg: 88,
};

export const HOME_PAGE_CONTAINER_PROPS = {
  px: HOME_PAGE_PX,
  boxSizing: "content-box" as const,
  maxW: "container.xl",
  mx: "auto",
};

export const HomePageSection = (props: BoxProps) => (
  <Box as="section" py={HOME_PAGE_PY} {...props} />
);

type HomePageSectionHeadingProps = {
  title: string;
  description: string;
} & BoxProps;

export const HomePageSectionHeading = ({
  title,
  description,
  ...props
}: HomePageSectionHeadingProps) => (
  <Box {...props}>
    <Heading mb="1">{title}</Heading>
    <Text fontSize="lg">{description}</Text>
  </Box>
);
